import React from "react"
import progressBars from "../../static/svgs/progressBar"
import useProgress from "./hooks/useProgress"

type Props = {
  isShown?: boolean
  footerHeight?: number
}

const ProgressBar = ({ isShown = true, footerHeight = 660 }: Props) => {
  const triangles = useProgress(footerHeight)

  return (
    <div
      className={`fixed top-1/4 left-1 sm:left-9 transition-opacity ${
        isShown ? "opacity-100" : "opacity-0"
      }`}
    >
      {Array.from(Array(25)).map((_, i) => (
        <img
          alt=""
          className={`${triangles === i ? "" : "h-0"}`}
          key={i}
          src={progressBars[i]}
        />
      ))}
    </div>
  )
}

export default ProgressBar
